var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_quest_keyboard_arrow_down",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_quest_keyboard_arrow_down)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 12.4792C9.88873 12.4792 9.78456 12.4618 9.68734 12.4271C9.59012 12.3924 9.49984 12.3333 9.4165 12.25L5.58317 8.41667C5.43039 8.26389 5.354 8.06944 5.354 7.83333C5.354 7.59722 5.43039 7.40278 5.58317 7.25C5.73595 7.09722 5.93039 7.02083 6.1665 7.02083C6.40261 7.02083 6.59706 7.09722 6.74984 7.25L9.99984 10.5L13.2498 7.25C13.4026 7.09722 13.5971 7.02083 13.8332 7.02083C14.0693 7.02083 14.2637 7.09722 14.4165 7.25C14.5693 7.40278 14.6457 7.59722 14.6457 7.83333C14.6457 8.06944 14.5693 8.26389 14.4165 8.41667L10.5832 12.25C10.4998 12.3333 10.4096 12.3924 10.3123 12.4271C10.2151 12.4618 10.1109 12.4792 9.99984 12.4792Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/icon_quest_keyboard_arrow_down.1b639ae670d2d3566e10033e271fd63f.svg";
export { ForwardRef as ReactComponent };